import { lazy, Suspense, useMemo } from "react";

const Step = (props) => {
  const DynamicField = lazy(() => import(`../../steps/${props.id}/index.js`));

  const DynamicField2 = useMemo(() => {
    return lazy(() => import(`../../steps/${props.id}/index.js`));
  }, [props.id]);

  return (
    <Suspense fallback={<div>...</div>}>
      <DynamicField2 {...props} />
    </Suspense>
  );
};

export default Step;
